import * as React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import userActions from './userActions';

import Utils from '../common/utils';

interface Props {
	currentUser: UserDetails;
	referrals: CustomerReferralResponse;
	actions: any;
}
class ReferralSection extends React.Component<Props> {
	componentDidMount() {
		this.props.actions.fetchReferrals(this.props.currentUser.id);
	}

	render() {
		return (
			<div className="dashboard-row dashboard-cell dashboard-cell-flex">
				<h3>Referral Balance: {Utils.formatCurrency(this.props.referrals.referralBalance)}</h3>
				<p>
					<strong>
						<Link to={`/user/${this.props.currentUser.id}/refer`}>
							Refer someone and you each receive credit towards the next payment!
						</Link>
					</strong>
				</p>
			</div>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		referrals: state.user.referrals
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ReferralSection);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/ReferralSection.tsx